import React from "react";
import { useState, useEffect, useReducer, useRef } from "react";
import "../KeywordTrackingFromInsideApp/keyword-tracking-component.css";
import { Fragment } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import Loading from "../SpinnerAndError/Loading";
import {
  Bars3BottomLeftIcon,
  ChartBarIcon,
  HomeIcon,
  XMarkIcon,
  ComputerDesktopIcon,
} from "@heroicons/react/24/outline";
import { Col, Card, message, Layout, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { FallOutlined } from "@ant-design/icons";
import { Spin } from "antd";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const YourProfilePage = () => {
  const [uploading, setUploading] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedMednuItem, setSelectedMenuItem] = useState("Meta checker");
  const [errorInFetching, setErrorInFetching] = useState(false);
  const [email, setEmail] = useState();
  const [overallLoading, setOverallLoading] = useState(false);
  const [firstTimeUser, setFirstTimeUser] = useState(false);
  const [isCustomerPaying, setIsCustomerPaying] = useState(false);

  const [inputForURL, setInputForURL] = useState("Your webpage");
  //FOR THE DRAWER:
  const [visible, setVisible] = useState(false);

  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0); // NOT USING THIS ONE AT THE MOMENT. REACT WRITES THAT IT IS BEST NOT TO USE: https://reactjs.org/docs/hooks-faq.html
  const [reRender, setRerender] = useState(0);

  const { Header, Content, Footer, Sider } = Layout;

  //THESE ARE THE TOKENS BELOW :
  const token = window.localStorage.getItem("token");
  const token2 = token?.slice(1, -1);

  const list = [FallOutlined];

  const navigation = [
    { name: "Dashboard", icon: HomeIcon, href: "/dashboard", current: false },
    {
      name: "Keyword tracker",
      icon: ChartBarIcon,
      href: "/keyword-tracker",
      current: false,
    },
    /* {
      name: "Reports",
      icon: UsersIcon,
      href: "/saved-reports",
      current: false,
    }, */
    {
      name: "Meta-tag generator",
      icon: ComputerDesktopIcon,
      href: "/meta-checker",
      current: false,
    },
    /* {
      name: "Schema Markup",
      icon: CodeBracketIcon,
      href: "/schema-generator",
      current: false,
    }, */
  ];

  const avatarOnClickFunction = (event) => {
    const eventName = event.target.innerText;

    if (eventName === "Sign out") {
      logoutFunction();
    }
  };

  const userNavigation = [
    { name: "Your Profile", href: "/profile" },
    /* { name: "Settings", href: "#" },  */
    { name: "Sign out", href: "#" },
  ];

  /* const secondaryNavigation = websiteDomainData?.map((data) => ({
    name: data,
    href: "/keyword-tracker" + "?" + "id=" + data,
  })); */

  //THIS IS THE COMPONENT DID MOUNT****************************: (IT NOW INCLUDES THE "IGNORE" WHICH IS USED TO UPDATE COMPONENTS.)
  useEffect(() => {
    if (!token) {
      localStorage.clear();
      window.location.replace("/");
    }
    fetchDataOnMount();
    setOverallLoading(true); //TURNING ON LOADER HERE
  }, [reRender]);

  const fetchDataOnMount = async () => {
    const response = await fetch(process.env.REACT_APP_PROFILE_SETTINGS, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token2}`,
      },
    });
    if (response.ok) {
      const data = await response.json();
      setOverallLoading(false); // TURNING OFF LOADER HERE.
      setLogoUrl(data.logoUrl);
      setEmail(data.email);
    } else if (response.status === 404) {
      console.log("data not found on mount");
      setOverallLoading(false); // TURNING OFF LOADER HERE.
    } else if (response.status === 500) {
      console.log("Something went wrong");
      setOverallLoading(false); // TURNING OFF LOADER HERE.
    }
  };

  //THESE BELOW ARE FOR THE GENERAL LAYOUT USING THE ANTD DESIGN:
  const onClick = ({ key }) => {
    message.info(`Click on item ${key}`);
    setSelectedMenuItem({ key });
  };

  const typeaheadRef = useRef(null); // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE

  // SIDER AND DRAWER TOGGLE
  const [isToggled, setToggled] = useState(false);
  const toggleTrueFalse = () => setToggled(!isToggled);
  const onClose = () => {
    setToggled(false);
  };

  const logoutFunction = () => {
    console.log("log me out please ");
    localStorage.clear();
    window.location.replace("/");
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "4px",
      border: "1px solid #d9d9d9;",
      /* color: "black", */
      borderRadius: state.isFocused ? "4px" : "4px",
      height: "56px",
      fontColor: "#d9d9d9",
      /*       borderRadius: state.isFocused ? "3px 3px 0 0" : 3, */
      borderColor: state.isFocused ? "#28a745" : "#28a745",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#28a745" : "#28a745",
      },
    }),
    menu: (base) => ({
      ...base,
      color: "black",
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      color: "black",
    }),
  };

  // ********** UNTIL HERE - ABOVE ARE ALL THE FUNCTIONS AND STYLES FOR THE "CHANGE GOOGLE REGION" MODAL **********

  const takeMeToTheDashboardPage = () => {
    window.location.assign("/dashboard");
  };

  let navigate = useNavigate();

  const navigateToPricesPageFunction = () => {
    navigate("/prices");
  };

  //BELOW ARE THE UPLOAD LOGO FUNCTION

  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB in bytes

  const uploadLogo = async (event) => {
    setUploading(true);
    const fileInput = event.target;
    const logoFile = fileInput.files[0];

    if (!logoFile) {
      // handle error - no file selected
      console.error("No file selected");
      message.info("No file selected", 5);
      setUploading(false);
      return;
    }

    if (!logoFile.type.startsWith("image/")) {
      // handle error - file is not an image
      console.error("Selected file is not an image");
      message.info("Selected file is not an image", 5);
      setUploading(false);
      return;
    }

    if (logoFile.size > MAX_FILE_SIZE) {
      // handle error - file is too large
      console.error("Selected file is too large");
      message.info(
        `File size must be no more than ${MAX_FILE_SIZE / 1024 / 1024} MB`,
        5
      );
      setUploading(false);
      return;
    }

    const formData = new FormData();
    formData.append("logo", logoFile);

    try {
      const response = await fetch(process.env.REACT_APP_UPLOAD_LOGO, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token2}`,
        },
        body: formData,
      });

      if (!response.ok) {
        // handle error - request failed
        console.error(`Request failed: ${response.status}`);
        message.error("Something went wrong - please try again later", 10);
        setUploading(false);
        return;
      }

      const result = await response.json();

      // handle success - do something with the result
      console.log(`File uploaded successfully`);
      message.success("Logo uploaded successfully", 10);
      setUploading(false);
      setRerender(result); // THIS IS JUST TO RE-RENDER THE COMPONENT
    } catch (error) {
      // handle error - network error
      console.error("Network error", error);
      message.error("Something went wrong - please try again later", 10);
    }
    setUploading(false);
  };

  //UNTIL HERE.

  return (
    <div>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-40 md:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>

          <div className="fixed inset-0 z-40 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-white pt-5 pb-4">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 right-0 -mr-12 pt-2">
                    <button
                      type="button"
                      className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </Transition.Child>
                <div
                  style={{ cursor: "pointer" }}
                  className="flex flex-shrink-0 items-center px-4"
                >
                  <img
                    className="h-12 w-auto"
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
                    alt="SerpMaze"
                    onClick={takeMeToTheDashboardPage}
                  />
                </div>
                <div className="mt-5 h-0 flex-1 overflow-y-auto">
                  <nav className="space-y-1 px-2">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current
                            ? "bg-gray-100 text-gray-900"
                            : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                          "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                        )}
                      >
                        <item.icon
                          className={classNames(
                            item.current
                              ? "text-gray-500"
                              : "text-gray-400 group-hover:text-gray-500",
                            "mr-3 flex-shrink-0 h-6 w-6"
                          )}
                          aria-hidden="true"
                        />
                        {item.name}
                      </a>
                    ))}
                  </nav>
                </div>
              </Dialog.Panel>
            </Transition.Child>
            <div className="w-14 flex-shrink-0" aria-hidden="true">
              {/* Dummy element to force sidebar to shrink to fit close icon */}
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
        {/* Sidebar component, swap this element with another sidebar if you like */}
        <div className="flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white pt-5">
          <div
            style={{ cursor: "pointer" }}
            className="flex flex-shrink-0 items-center px-4"
          >
            <img
              className="h-12 w-auto"
              src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
              alt="SerpMaze"
              onClick={takeMeToTheDashboardPage}
            />
          </div>
          <div className="mt-5 flex flex-grow flex-col">
            <nav className="flex-1 space-y-1 px-2 pb-4">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                    "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                  )}
                >
                  <item.icon
                    className={classNames(
                      item.current
                        ? "text-gray-500"
                        : "text-gray-400 group-hover:text-gray-500",
                      "mr-3 flex-shrink-0 h-6 w-6"
                    )}
                    aria-hidden="true"
                  />
                  {item.name}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>
      <div className="flex flex-1 flex-col md:pl-64">
        <div className="sticky top-0 z-10 flex h-16 flex-shrink-0 bg-white shadow">
          <button
            type="button"
            className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <Bars3BottomLeftIcon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div className="flex flex-1 justify-between px-4">
            <div className="flex flex-1">
              <form className="flex w-full md:ml-0" action="#" method="GET">
                <label htmlFor="search-field" className="sr-only">
                  Search
                </label>
                <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                  <span />
                </div>
              </form>{" "}
            </div>
            <div className="ml-4 flex items-center md:ml-6">
              {/* Profile dropdown */}
              <Menu as="div" className="relative ml-3">
                <div>
                  <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                    <span className="sr-only">Open user menu</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    {userNavigation.map((item) => (
                      <Menu.Item key={item.name}>
                        {({ active }) => (
                          <a
                            onClick={avatarOnClickFunction}
                            href={item.href}
                            className={classNames(
                              active ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm text-gray-700"
                            )}
                          >
                            {item.name}
                          </a>
                        )}
                      </Menu.Item>
                    ))}
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>
        </div>

        <main className="flex-1">
          <div className="py-6">
            {/* <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                <h1 className="text-2xl font-semibold text-gray-900">
                  Dashboard
                </h1>
              </div> */}
            <div className="">
              {" "}
              {/* mx-auto max-w-7xl px-4 sm:px-6 md:px-8 */}
              {/* Replace with your content */}
              {/*                 <div className="py-4">
                  <div className="h-96 rounded-lg border-4 border-dashed border-gray-200" />
                </div>
 */}
              {/* /End replace */}
              {overallLoading === true ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Loading />
                </div>
              ) : (
                <Content>
                  <section className="general-layout ant-layout">
                    <main className="general-layout-content ant-layout-content">
                      <div className="ant-card analysis-form-card ant-card-bordered"></div>

                      <div className="outer-wrapper-for-body-content">
                        <Col xs={24} xl={24}>
                          <Card
                            title={
                              <div className="card-title-body">
                                <span className="card-title">
                                  Your profile information
                                </span>
                                {/* <small>Change your information</small> */}
                              </div>
                            }
                            extra={
                              <div className="overall-seo-score-body">
                                {/*  <div className="card-link-div">
                            View report <CaretRightOutlined />
                          </div> */}
                                &nbsp;&nbsp;
                              </div>
                            }
                            style={{
                              width: "100%",
                              minHeight: "900px",
                            }}
                          >
                            <small>Your email address</small>
                            <Input
                              size="large"
                              placeholder="large size"
                              prefix={<email />}
                              defaultValue={email ? email : "Email"}
                              disabled
                            />
                            <br></br>
                            {logoUrl ? (
                              <small>Upload a new logo</small>
                            ) : (
                              <small>Upload a logo</small>
                            )}
                            <div>
                              {uploading && (
                                <Spin
                                  size="large"
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                  }}
                                />
                              )}
                              <input
                                type="file"
                                name="logo"
                                id="logo"
                                accept="image/*"
                                onChange={uploadLogo}
                              />
                              <br></br>
                              <br></br>
                              {logoUrl && (
                                <img
                                  src={logoUrl}
                                  alt="Logo"
                                  style={{
                                    maxWidth: "200px",
                                    maxHeight: "200px",
                                  }}
                                />
                              )}
                            </div>
                          </Card>
                        </Col>
                      </div>
                    </main>
                  </section>
                </Content>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
export default YourProfilePage;
